import axios from '../../config/axiosConfig';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { loadAppSettingsFailure, loadAppSettingsSuccess } from './appSettings.actions';

import { appSettingsActionTypes, AppSettingsConfig} from './models';

// TODO: Type db response object
/**
 * Fetches appSettings from db, then dispatches an action with the corresponding result
 */
export function* loadAppSettingsAsyncSaga(): Generator {
  try {
    const response = yield axios.get<AppSettingsConfig>('api/appSettingsUI')
      .then((res) => res.data);
    yield put(loadAppSettingsSuccess(<AppSettingsConfig>response));
  } catch (error) {
    yield put(loadAppSettingsFailure(error as string));
  }
}

/**
 * Listens for LOAD_APPSETTINGS_START action, dispatchs loadAppSettingsAsyncSaga
 */
export function* loadAppSettingsStartSaga(): Generator {
  yield takeLatest(appSettingsActionTypes.LOAD_APPSETTINGS_START, loadAppSettingsAsyncSaga);
}

/**
 * Composite of all appSettings sagas that are listening for external actions
 */
export function* appSettingsSagas(): Generator {
  yield all([call(loadAppSettingsStartSaga)]);
}

export default appSettingsSagas;